import React from 'react'
import { Button, CustomInput, CustomSelect, FormFieldSet, TableAdv, useFormHandler } from '../../../../../components'
import { mapTableRows } from '../../../../../utils'
import { openinvoicedata } from '../../../../../assets/data/candidatesData'
import { DropDownFilteroptions, upcommingpayfrequency } from '../../../../../assets/data/projectData'
import { usePagination } from '../../../../../hooks'
const Payments = () => {
   const { page, limit, setPage, handleLimitChange } = usePagination(
      10,
      (newPage, newLimit) => {},
    );
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      Search: "",
      InvoiceDate: ""
    }

  )



  const tableData = openinvoicedata
  const columns = [

    {
      key: "client",
      label: "Client",
    },
    {
      key: "clientID",
      label: "Client ID",
    },
    {
      key: "paymentDate",
      label: "Payment Date",
    },
    {
      key: "paymentMethod",
      label: "Payment Method",
    },
    {
      key: "referenceNumber",
      label: "Reference Number",
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
    },
    {
      key: "homeCurrency",
      label: "Home Currency",
    },
    {
      key: "credit Amount",
      label: "CreditAmount",
    },
    {
      key: "discountAmount",
      label: "Discount Amount",
    },
    {
      key: "accountType",
      label: "Account Type",
    }


  ];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <TableAdv
      tableId={`clients_invoicesandpayments_payments`}
      rows={mappedRows}
      columns={columns}
      showSlNo
      serverPagination={true}
      totalCount={tableData?.length}
      page={page}
      limit={limit}
      onPaginationChange={setPage}
      onLimitChange={handleLimitChange}
      toolbarRight={{
        search: false,
        filter: true,
        download: false,
        add: [
          {
            component: (
              <div className="flex gap-3">
                <div className="min-w-[200px] mt-0.5">
                  <FormFieldSet
                    type="text"
                    title="   "
                    placeholder=" Invoice No,Client,Employee"
                    value={formData.Search}
                    onChange={(value) => handleChange("Search", value)}

                    size="sm"
                  />
                </div>
                <div className="min-w-[200px]">
                  <FormFieldSet
                    type="select"
                    title="Invoice Date"
                    placeholder="Select InvoiceDate"
                    value={formData.InvoiceDate}
                    onChange={(value) => handleChange("InvoiceDate", value)}
                    options={DropDownFilteroptions}
                    size="sm"
                  />
                </div>
                <div className="flex justify-end items-end mb-1.5">
                  <Button title="Search" size="sm" />
                </div>
              </div>
            ),
          },

        ],
      }}
    />
  )
}

export default Payments